import React, { Component } from "react";
import { Field, reduxForm } from 'redux-form';
import ReCAPTCHA from "react-google-recaptcha";
import { connect } from 'react-redux';
import contactForm from '../../api/axios';
import history from "../../history";
import "./Form.css";    

class ContactForm extends Component{
    constructor(props){
        super(props)
        this.state = {
            token: ''
        }
        this.recaptchaRef = React.createRef();
    }

    renderError = ({error, touched}) => {
        //console.log("CHECK IF TOUCHED: ", error, touched)
        if(error && touched){
            //console.log("@@@ TOUCHED: ", error, touched)
            return (
                <div className="position-absolute">
                    <p className="fw-light error-color">{error}</p>
                </div>
            );
        }
    }

    renderItem = ({input, label, meta, type}) => {
        const className = `${(meta.error && meta.touched)? 'form-control border-color' : 'form-control'}`;
        //console.log("RENDER CLASSNAME: ", className)
        return (
            <div className="pb-3">
                <label className="title-color">{label}</label>
                <input 
                    className={`${className} w-100 pl-5`} 
                    type={type} 
                    {...input} 
                    autoCapitalize="word"
                    autoComplete="off" 
                />
                {this.renderError(meta)}
            </div>
        );
    }

    renderTextItem = ({input, label, meta, type}) => {
        const className = `${(meta.error && meta.touched)? 'form-control border-color' : 'form-control'}`;
        //console.log("RENDER CLASSNAME: ", className)
        return (
            <div className="pb-3">
                <label className="title-color">{label}</label>
                <textarea 
                    className={`${className} w-100 pl-3 p-4 pt-2`} 
                    {...input}
                    autoComplete="off" 
                    style={{resize: "none"}}
                />
                {this.renderError(meta)}
            </div>
        );
    }

    submitForm = async (formValues) => {
        const { showLoader, hideLoader } = this.props;
        //showLoader();
        this.recaptchaRef.current.execute().then((token) => {
            this.setState({token}, () => {
                const { token } = this.state;
                console.log("@@@ CAPTCHA: ", token, formValues);
                contactForm.post('/', {
                    contact: 1,
                    token: token,
                    first_name: formValues.firstName,
                    last_name: formValues.lastName,
                    company: formValues.company,
                    email: formValues.email,
                    comment: formValues.message
                }).then((response) => {
                    //hideLoader();
                    console.log("CONTACT RESPONSE: ", response);
                    if(response.data.status === 1){
                        history.push('/');
                        alert(response.data.message);
                        this.props.gotoHome();
                    }
                }).catch((error) => {
                    //hideLoader();
                    console.log("CONTACT ERROR: ", error);
                    alert(error);
                })
                //hideLoader();
            })
        }).catch((err) => {
            alert(err);
            //hideLoader();
        })
    }

    render(){
        return (
            <main id="main">
                <section id="contact" className="contact mt-5">
                    <div className="container">

                        <div className="section-title" data-aos="zoom-out">
                            <h2>Contact</h2>
                            <p>Contact Us</p>
                        </div>

                        <div className="row mt-5">

                            <div className="col-lg-4" data-aos="fade-right">
                                <div className="info">
                                    <div className="address">
                                        <i className="bi bi-geo-alt"></i>
                                        <h4>Location:</h4>
                                        <p>A108 Adam Street, New York, NY 535022</p>
                                    </div>

                                    <div className="email">
                                        <i className="bi bi-envelope"></i>
                                        <h4>Email:</h4>
                                        <p>info@example.com</p>
                                    </div>

                                    <div className="phone">
                                        <i className="bi bi-phone"></i>
                                        <h4>Call:</h4>
                                        <p>+1 5589 55488 55s</p>
                                    </div>
                                </div>

                            </div>

                            <div className="col-lg-8 mt-5 mt-lg-0" data-aos="fade-left">

                                <form className="php-email-form" onSubmit={this.props.handleSubmit(this.submitForm)}>
                                    <div className="row">
                                        <div className="col-md-6 form-group">
                                            <Field className="form-control" name="firstName" type="text" component={this.renderItem} label="First Name*"/>
                                        </div>
                                        <div className="col-md-6 form-group mt-3 mt-md-0">
                                            <Field className="form-control" name="lastName" type="text" component={this.renderItem} label="Last Name*"/>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-6 form-group">
                                            <Field className="form-control" name="email" type="email" component={this.renderItem} label="E-mail*"/>
                                        </div>
                                        <div className="col-md-6 form-group mt-3 mt-md-0">
                                            <Field className="form-control" name="company" type="text" component={this.renderItem} label="Company Name*"/>
                                        </div>
                                    </div>
                                    <div className="pt-3">
                                        <Field 
                                            className="form-control w-100 pl-3 p-4" 
                                            name="message" 
                                            component={this.renderTextItem} 
                                            label="Message*"
                                        />
                                    </div>
                                    <div className="text-center">
                                        <button className="button-color rounded-pill">SUBMIT</button>
                                    </div>
                                </form>

                            </div>

                        </div>

                    </div>
                    <div>
                        <ReCAPTCHA
                            ref={this.recaptchaRef}
                            size="invisible"
                            sitekey="6LcGC4ceAAAAAK-2mg8oUKuqT1wNmHVu9ScTi_CY"
                            //onChange={(token) => this.setState({token}, () => console.log("CAPTCHA: ", this.state.token))}
                        />
                    </div>
                </section>
            </main>
        )
    }
}

const validate = (formValues) => {
    //console.log("VALIDATION: ", formValues)
    const errors = {};
    const firstName = 'firstName';
    const lastName = 'lastName';
    const email = 'email';
    const company = 'company';
    const message = 'message';
    const propsList = Object.keys(formValues);
    propsList.forEach((name) => {
        if(name === firstName || name === lastName){
            //console.log("BEFORE: ", formValues[name])
            const text = formValues[name].replace(/[^A-Za-z ]/gi,'').trim();
            formValues[name] = text.replace(/^\w/, (c) => c.toUpperCase());
            //console.log("AFTER: ", formValues[name])
        }else if(name === email){
            const check = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const text = formValues[name].toLowerCase();
            const trimmedText = text.trim();
            if(check.test(String(trimmedText))){
                formValues[name] = trimmedText;
            }else{
                formValues[name] = trimmedText;
                errors[name] = 'Invalid E-mail';
            }
        }else if(name === company){
            const text = formValues[name].replace(/[^A-Za-z ]/gi,'').trimLeft();
            formValues[name] = text.replace(/^\w/, (c) => c.toUpperCase());
        }else if(name === message){
            const text = formValues[name].replace(/[^A-Za-z ]/gi,'').trimLeft();
            formValues[name] = text.replace(/^\w/, (c) => c.toUpperCase());
        }
    })
    if(!formValues[firstName]){
        errors[firstName] = "First Name is required";
    }
    if(!formValues[lastName]){
        errors[lastName] = "Last Name is required";
    }
    if(!formValues[email]){
        errors[email] = "Email is required";
    }
    if(!formValues[company]){
        errors[company] = "Company Name is required";
    }
    if(!formValues[message]){
        errors[message] = "Message is required";
    }
    return errors;
}

export default connect(null)(reduxForm({
    form: 'contact-us',
    validate
})(ContactForm));